import { TransitionPromptHook, Location, History } from 'history';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import ActionsModal from '../ActionsModal/ActionsModal';

export type UnsavedChangesModalProps<T> = {
  isOpen?: boolean;
  onClose: () => void;
  onDropChanges: (history: History<T>, nextLocation: Location<T> | undefined) => void;
  onRouteChangeBlock?: TransitionPromptHook<T>;
};

const UnsavedChangesModal = <T extends { forceRouteChange: boolean }>({
  isOpen,
  onClose,
  onDropChanges,
  onRouteChangeBlock,
}: UnsavedChangesModalProps<T>) => {
  const [nextLocation, setNextLocation] = useState<Location<T> | undefined>();
  const history = useHistory<T>();

  useEffect(() => {
    if (!onRouteChangeBlock) {
      return;
    }

    const unblock = history.block((location, action) => {
      if (location.state?.forceRouteChange) {
        return;
      }

      setNextLocation(location);
      return onRouteChangeBlock?.(location, action);
    });

    return () => unblock();
  }, [history, onRouteChangeBlock]);

  return (
    <ActionsModal
      isOpen={isOpen}
      heading="campaigns.form.unsaved-changes.heading"
      description="campaigns.form.unsaved-changes.description"
      actions={[
        {
          label: 'campaigns.form.unsaved-changes.action-leave',
          size: 'small',
          variant: 'secondaryNegative',
          onClick: () => onDropChanges(history, nextLocation),
        },
        {
          label: 'campaigns.form.unsaved-changes.action-continue-editing',
          size: 'small',
          variant: 'secondary',
          onClick: () => onClose(),
        },
      ]}
      onClose={onClose}
    />
  );
};

export default UnsavedChangesModal;
